/**
 * Fatiado de lib/api.ts por domínio (#131, regra R3) — Web Push (#124 PR-3):
 * chave pública VAPID e subscrições do dispositivo (canais waiter/kitchen).
 * Contratos em packages/api/src/features/push/routes.ts.
 */
import { get, post, request } from './client.js'

export type PushChannel = 'waiter' | 'kitchen'

export type PushSubscribeInput = {
  endpoint: string
  keys: { p256dh: string; auth: string }
  channel: PushChannel
  /** User-Agent do browser (a API trunca a 200). */
  user_agent?: string
}

export const pushApi = {
  /** 503 PUSH_UNAVAILABLE sem os secrets VAPID no ambiente. */
  vapidPublicKey: () => get<{ public_key: string }>('/admin/push/vapid-public-key'),

  /** 201 (novo) / 200 (upsert — mesmo endpoint+canal não duplica). */
  subscribe: (body: PushSubscribeInput) =>
    post<{ id: string; channel: PushChannel }>('/admin/push/subscriptions', body),

  /** 204 idempotente — apaga a subscrição DESTE utilizador no endpoint. */
  removeSubscription: (body: { endpoint: string; channel?: PushChannel }) =>
    request<void>('DELETE', '/admin/push/subscriptions', body),
}
